const Error404 = () => import( './Errors.404.vue' );
const NotAuthenticated = () => import( './NotAuthenticated.vue' );
const VehicleSetupIncomplete = () => import( './VehicleSetupIncomplete.vue' );

export default [ 
    {
        path: '/login',
        name: 'Login',
        meta: {
            allowAnonymous: true, 
            title: 'Error'
        },
        component: NotAuthenticated
    },
    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        meta: {
            allowAnonymous: true, 
            title: 'Not Found'
        },
        component: Error404
    },
    {
        path: '/vehicle-setup-incomplete',
        name: 'Vehicle Setup Incomplete',
        meta: {
            allowAnonymous: true, 
            title: 'Vehicle Setup Incomplete'
        },
        component: VehicleSetupIncomplete
    }    
];
